import React, { Component } from 'react';

import { Label, Headline, Disclaimer, Button } from '../../theme';
import { Washing } from '../../svg';
import { isMobile } from '../../util';

class WashingSolution extends Component {
  render() {
    return (
      <div id="RufeSol" className="container__fluid page__solution">
        {
          !isMobile && (
            <div className="start birds">
              <Washing.Birds />
            </div>
          )
        }
        <div className="w__flex w__flex-column Justify-center Justify-start__mobile">
          <Label
            marginLeft={isMobile ? false : '20vw'}
            background="#840050"
          >
            solutia mamei
          </Label>
          {
            isMobile
              ? <Headline small >
                <p style={{ color: '#d33c64' }}>O MASINA DE SPALAT NOUA,</p>
                <p style={{ color: '#d33c64' }}>CLASA A+++, CU CAPACITATE</p>
                <p style={{ color: '#d33c64' }}>MAI MARE, VINE LA PACHET</p>
                <p style={{ color: '#d33c64' }}>SI CU ENERGIE ECONOMISITA.</p>
              </Headline>
              : <Headline padding="20vw" small alignLeft >
                <p style={{ color: '#d33c64' }}>CUMPARA O MASINA DE SPALAT NOUA,</p>
                <p style={{ color: '#d33c64' }}>CU CAPACITATE MAI MARE DE INCARCARE</p>
                <p style={{ color: '#d33c64' }}>SI CLASA ENERGETICA SUPERIOARA (A+++).</p>
                <p style={{ color: '#d33c64' }}>MAI PUTINE SPALARI, MAI MULTE ECONOMII.</p>
              </Headline>
          }
          <div className="w__flex Align-right w__flex-column__mobile Align-left__mobile">
            <Disclaimer
              style={{
                paddingLeft: isMobile ? '0' : '20vw'
              }}
            >
              <span>
                Comparativ cu cele din clasa energetica A, <strong>masinile de spalat
                  <br className="mobile__hidden" />
                &nbsp;din clasa A+++ consuma cu 22% mai putina energie electrica.</strong>
              </span>
            </Disclaimer>
            <span>
              <Button to="https://www.arctic.ro/masini-de-spalat-rufe.html" arctic>
                <span className="mobile__hidden">Vezi</span>  produsele arctic
              </Button>
              {
                isMobile && (
                  <Button enel >
                    <span className="mobile__hidden">Vezi</span>  oferta enel
                  </Button>
                )
              }
            </span>
          </div>

        </div>
        <div className="end family">
          <Washing.Dancing />
        </div>
        {
          !isMobile && (
            <Button enel >
              <span className="mobile__hidden">Vezi</span>  oferta enel
          </Button>
          )
        }
      </div>
    );
  }
}

export default WashingSolution;


// WEBPACK FOOTER //
// ./src/components/pages/Rufe/WashingSolution.jsx